import React, {useState} from "react";
import {Button, Popconfirm} from "antd";

export default ({confirm, onClick, keepLoading, ...props}) => {
  const [loading, setLoading] = useState(false);

  let click = async () => {
    setLoading(true);
    try {
      await onClick();
      setLoading(keepLoading);
    }
    catch (e) {
      alert("error making request");
      setLoading(false);
      throw e;
    }
  }

  if (confirm)
    return <Popconfirm title={confirm} onConfirm={onClick}>
      <Button loading={loading} {...props} />
    </Popconfirm>

  return <Button onClick={click} loading={loading} {...props} />
}

